import "./_Bootstrap/Bootstrap";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { LayerProvider, type UIContextType, UIProvider } from "@onshopfront/components";
import { store } from "./_Bootstrap/RoutingAndStore";
import Developer from "./Developer";
// Bootstrap the application

const FLOATING_ROOT = "floating-root-container";

const uiContext: Partial<UIContextType> = {
    rootId: FLOATING_ROOT,
};

// Render our application
createRoot(document.getElementById("root") as Element).render(
    <Provider store={store}>
        <BrowserRouter>
            <UIProvider value={uiContext}>
                <LayerProvider zIndex={22}>
                    <Developer />
                </LayerProvider>
                <div
                    id={FLOATING_ROOT}
                    className="pointer-events-none absolute inset-0 overflow-hidden"
                />
            </UIProvider>
        </BrowserRouter>
    </Provider>
);
